import React from 'react';
import { motion } from 'framer-motion';

const WaveGraphic = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden bg-white">
      {/* Background Image Container */}
      <div className="absolute inset-0 w-full h-[100vh]">
        <div 
          className="w-full h-[100vh] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/images/color-system.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(10px)',
            zIndex: 1,
           }}
        />
      </div>
      
      {/* Floating Particles */}
      {[...Array(15)].map((_, index) => (
        <motion.div
          key={index}
          className="absolute w-1 h-1 rounded-full"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 60 + 20}%`,
            background: `hsl(${Math.random() * 360}, 70%, 60%)`,
          }}
          initial={{ 
            opacity: 0, 
            scale: 0,
            y: 20 
          }}
          animate={{ 
            opacity: [0, 1, 0], 
            scale: [0, 1, 0],
            y: [-20, 0, 20]
          }}
          transition={{ 
            duration: 3 + Math.random() * 2, 
            repeat: Infinity,
            delay: Math.random() * 2,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  );
};

export default WaveGraphic;
